import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function AddEditBehindTheIdea() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);


  const [form, setForm] = useState({
    name: "",
    position: "",
    description: "",
    imageUrl: "",
  });

  useEffect(() => {
    if (isEdit) {
      axios
        .get(`https://api.livestockify.com/api/admin/behind-idea/${id}`)
        .then((res) => {
          const data = res.data;
          setForm({
            name: data.name || "",
            position: data.position || "",
            description: data.description || "",
            imageUrl: data.imageUrl || data.image || "",
          });
        });
    }
  }, [id, isEdit]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (isEdit) {
      axios.put(`https://api.livestockify.com/api/admin/behind-idea/${id}`, form);
    } else {
      axios.post("https://api.livestockify.com/api/admin/behind-idea", form);
    }

    navigate("/uploads/behind-idea");
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 pl-14 md:pl-8">
        <h1 className="text-lg font-semibold text-green-700 mb-8">
          {isEdit ? "Edit Behind the Idea" : "Add Behind the Idea"}
        </h1>

        <div className="max-w-3xl mx-auto space-y-6 w-full">
          {[
            ["Name", "name"],
            ["Position", "position"],
            ["imageUrl", "imageUrl"],
          ].map(([label, name]) => (
            <div
              key={name}
              className="grid grid-cols-1 md:grid-cols-[200px_1fr] items-center gap-3 md:gap-6"
            >
              <label className="text-sm font-medium text-center">{label}</label>
              <input
                name={name}
                value={form[name]}
                onChange={handleChange}
                className="max-w-[420px] border rounded-md px-3 py-2 text-sm"
              />
            </div>
          ))}

          {/* DESCRIPTION */}
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] items-start gap-3 md:gap-6">
            <label className="text-sm font-medium text-center">
              Description
            </label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              className="w-full max-w-[420px] border rounded-md px-3 py-2 text-sm"
            />
          </div>

          {/* ACTIONS */}
          <div className="flex justify-end gap-4 pt-6 max-w-[620px]">
            <button
              onClick={() => navigate("/uploads/behind-idea")}
              className="border px-6 py-2 rounded-md text-sm"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="bg-green-600 text-white px-6 py-2 rounded-md text-sm"
            >
              {isEdit ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
